"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeModelCollectionWriter = void 0;
const form_field_1 = require("../fields/form.field");
const capture_provider_1 = require("../fields/provider/capture.provider");
const collection_model_write_brightnessCorrection_1 = require("./collection.model.write.brightnessCorrection");
const collection_model_write_cropParameter_1 = require("./collection.model.write.cropParameter");
const collection_model_write_drawable_1 = require("./collection.model.write.drawable");
const collection_model_write_field_1 = require("./collection.model.write.field");
const collection_model_write_imageVisibility_1 = require("./collection.model.write.imageVisibility");
const MEASUREMENT_STATE_TYPE = 'truesize';
class IkeModelCollectionWriter {
    static writeField(collectionField) {
        return collection_model_write_field_1.FieldWriters[collectionField.schema.type](collectionField);
    }
    static writeData(instance) {
        const instanceData = {
            _id: instance.instanceId
        };
        for (const schemaField of instance.schema.fields) {
            if (!instance.hasField(schemaField.id)) {
                continue;
            }
            const field = instance.getField(schemaField.id);
            if (form_field_1.CollectionModelFieldSubForm.isSubFormField(field)) {
                instanceData[schemaField.id] = field.value.map(ins => IkeModelCollectionWriter.writeData(ins));
            }
            else if (field.hasValue()) {
                instanceData[schemaField.id] = IkeModelCollectionWriter.writeField(field);
            }
        }
        return instanceData;
    }
    static writeCollectionMeasurements(model) {
        const output = {};
        const captures = capture_provider_1.CaptureProvider.getCaptureIds(model);
        for (const captureId of captures) {
            const capture = model.state.getCapture(captureId);
            if (capture == null) {
                continue;
            }
            const state = model.getDrawableState(captureId);
            for (const drawable of state.values()) {
                output[captureId] = output[captureId] || { state: [], type: MEASUREMENT_STATE_TYPE, captureId };
                if (output[captureId].state.find(existing => existing.id === drawable.id)) {
                    continue;
                }
                const val = collection_model_write_drawable_1.DrawableWriter.write(model, drawable);
                if (val == null) {
                    continue;
                }
                output[captureId].state.push(val);
                output[captureId].captureId = captureId;
            }
        }
        return output;
    }
    static writeCollectionBrightnessCorrections(model) {
        const output = {};
        const captures = capture_provider_1.CaptureProvider.getCaptureIds(model);
        for (const captureId of captures) {
            const capture = model.state.getCapture(captureId);
            if (capture == null) {
                continue;
            }
            const state = model.getBrightnessCorrectionState(captureId);
            for (const brightnessCorrection of state.values()) {
                output[captureId] = output[captureId] || { state: [], type: capture.type, captureId };
                if (output[captureId].state.find(existing => existing.id === brightnessCorrection.id)) {
                    continue;
                }
                const val = collection_model_write_brightnessCorrection_1.BrightnessCorrectionWriter.write(brightnessCorrection);
                if (val == null) {
                    continue;
                }
                output[captureId].state.push(val);
                output[captureId].captureId = captureId;
            }
        }
        return output;
    }
    static writeImageVisibilities(model) {
        const output = {};
        const captures = capture_provider_1.CaptureProvider.getCaptureIds(model);
        for (const captureId of captures) {
            const capture = model.state.getCapture(captureId);
            if (capture == null) {
                continue;
            }
            const state = model.getImageVisibilityState(captureId);
            if (state.hasImageVisibility()) {
                const imageVisibility = state.getImageVisibility();
                output[captureId] = output[captureId] || { state: undefined, type: capture.type, captureId };
                output[captureId].state = collection_model_write_imageVisibility_1.ImageVisibilityWriter.write(imageVisibility);
                output[captureId].captureId = captureId;
            }
        }
        return output;
    }
    static writeCollectionCropParameters(model) {
        const output = {};
        const captures = capture_provider_1.CaptureProvider.getCaptureIds(model);
        for (const captureId of captures) {
            const capture = model.state.getCapture(captureId);
            if (capture == null) {
                continue;
            }
            const state = model.getCropParameterState(captureId);
            for (const cropParameter of state.values()) {
                output[captureId] = output[captureId] || { state: [], type: capture.type, captureId };
                if (output[captureId].state.find(existing => existing.id === cropParameter.id)) {
                    continue;
                }
                const val = collection_model_write_cropParameter_1.CropParameterWriter.write(cropParameter);
                if (val == null) {
                    continue;
                }
                output[captureId].state.push(val);
                output[captureId].captureId = captureId;
            }
        }
        return output;
    }
}
exports.IkeModelCollectionWriter = IkeModelCollectionWriter;
//# sourceMappingURL=collection.model.write.js.map